/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.contentstaging.rpc.ContentStagingPublishRpc
 */
import * as References from './ContentStagingPublishRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.contentstaging.rpc.ContentStagingPublishRpc#schedulePublish
 */
export const SCHEDULE_PUBLISH_MUTATION_FIELD_NAME = 'com_hubspot_contentstaging_rpc_ContentStagingPublishRpc_schedulePublish';
export const SCHEDULE_PUBLISH_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SCHEDULE_PUBLISH_MUTATION_FIELD_NAME,
  args: ['contentIds', 'domainName', 'publishAt', 'name', 'description'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.schedulePublishRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.contentstaging.rpc.ContentStagingPublishRpc#getUrlDiscrepancies
 */
export const GET_URL_DISCREPANCIES_QUERY_FIELD_NAME = 'com_hubspot_contentstaging_rpc_ContentStagingPublishRpc_getUrlDiscrepancies';
export const GET_URL_DISCREPANCIES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_URL_DISCREPANCIES_QUERY_FIELD_NAME,
  args: ['contentIds', 'domainName'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getUrlDiscrepanciesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.contentstaging.rpc.ContentStagingPublishRpc#getUrlConflicts
 */
export const GET_URL_CONFLICTS_QUERY_FIELD_NAME = 'com_hubspot_contentstaging_rpc_ContentStagingPublishRpc_getUrlConflicts';
export const GET_URL_CONFLICTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_URL_CONFLICTS_QUERY_FIELD_NAME,
  args: ['contentIds', 'domainName'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getUrlConflictsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.contentstaging.rpc.ContentStagingPublishRpc#getSummary
 */
export const GET_SUMMARY_QUERY_FIELD_NAME = 'com_hubspot_contentstaging_rpc_ContentStagingPublishRpc_getSummary';
export const GET_SUMMARY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SUMMARY_QUERY_FIELD_NAME,
  args: ['contentIds', 'domainName'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getSummaryRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});